import { ACTIONS } from '../config/constants';

export default (state = null, action) => {
  switch (action.type) {
    case ACTIONS.TYPES.APP.FETCH_FILTERED_SUCCESS: {
      if (!state) {
        //TODO Someday fix to properly init state (propsToState that use "state.filtered ? "
        state = {};
      }
      return action.history;
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/filtered.reducer.js